<template>
  <v-container fluid grid-list-xl>
  <v-flex>
      <v-card>
        <div>
          <v-subheader class="headline">Personality System Graph</v-subheader>
        </div>

        <v-divider />

        <v-card-media id="testing" class="mt-3">
          <v-layout wrap row align-center justify-center fill-height class="px-4">
          <v-flex xs12 md12 sm12 lg4>
              <material-chart-card
                :data="chartLeast.data"
                :options="chartLeast.options"
                color="info"
                type="Line"
                class="elevation-2"
              >
                  <p class="category d-inline-flex font-weight-light title">
                  <v-icon color="blue">arrow_right</v-icon>&nbsp;
                  Core Private Self
                </p>

                <template slot="actions" v-if="applicant_detail.core_private != null">
                    <blockquote class="body-2 grey--text font-weight-bold font-italic ml-2">
                      {{applicant_detail.core_private.disc_type}}
                      <v-icon color="grey" small dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.core_private.profile}}
                    </blockquote>
                </template>

                <template slot="actions" v-else>
                    <blockquote class="body-2 red--text font-weight-bold font-italic ml-2">
                      #N/A
                    </blockquote>
                </template>
              </material-chart-card>
            </v-flex>
            
            <v-flex xs12 md12 sm12 lg4>
              <material-chart-card
                :data="chartMost.data"
                :options="chartMost.options"
                color="info"
                type="Line"
                class="elevation-2"
              >
                
                <p class="category d-inline-flex font-weight-light title">
                  <v-icon color="blue" >arrow_right</v-icon>&nbsp;
                  Mask Public Self
                </p>

                <template slot="actions" v-if="applicant_detail.mask_public != null">
                    <blockquote class="body-2 grey--text font-weight-bold font-italic ml-2">
                      {{applicant_detail.mask_public.disc_type}}
                      <v-icon color="grey" small dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.mask_public.profile}}
                    </blockquote>
                </template>

                <template slot="actions" v-else>
                    <blockquote class="body-2 red--text font-weight-bold font-italic ml-2">
                      #N/A
                    </blockquote>
                </template>
              </material-chart-card>
            </v-flex>

            <v-flex xs12 md12 sm12 lg4>
              <material-chart-card
                :data="chartChange.data"
                :options="chartChange.options"
                color="info"
                type="Line"
                class="elevation-2"
              >
                <p class="category d-inline-flex font-weight-light title">
                  <v-icon color="blue">arrow_right</v-icon>&nbsp;
                  Mirror Perceived Self
                </p>

                <template slot="actions" v-if="applicant_detail.mirror_perceived != null">
                    <blockquote class="body-2 grey--text font-weight-bold font-italic ml-2">
                      {{applicant_detail.mirror_perceived.disc_type}}
                      <v-icon color="grey" small dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.mirror_perceived.profile}}
                    </blockquote>
                </template>

                <template slot="actions" v-else>
                    <blockquote class="body-2 red--text font-weight-bold font-italic ml-2">
                      #N/A
                    </blockquote>
                </template>
              </material-chart-card>
            </v-flex>
          </v-layout>
        </v-card-media>
      </v-card>
    </v-flex>
    
    <br />

    <v-flex xs12>
      <v-card>
        <div>
          <v-subheader class="headline">Gambaran Diri</v-subheader>
        </div>

        <v-divider />

        <v-card-text>
        <!-- CORE PRIVATE SELF -->
          <v-expansion-panel
            v-model="panel2"
            expand
            popout
          >
            <v-expansion-panel-content expand-icon="mdi-menu-down">
              <div slot="header">
                <h4 class="font-weight-medium">
                  Core Private Self
                  <span
                    class="grey--text font-subtitle"
                  >(Gambaran kepribadian ketika menghadapi tekanan)</span>
                </h4>
              </div>
              <v-card v-if="applicant_detail.core_private != null">
                <v-card-text class="blue--text py-0">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      {{applicant_detail.core_private.disc_type}}
                      <v-icon color="grey" dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.core_private.profile}}
                    </blockquote>
                  </h3>
                </v-card-text>
                <v-divider inset></v-divider>
                <v-card-text class="pt-0">
                  <h4>
                    <blockquote
                      style="font-size:14px"
                      class="font-italic font-weight-regular"
                    >{{applicant_detail.core_private.characteristics}}</blockquote>
                  </h4>
                </v-card-text>
              </v-card>

              <v-card v-else>
                 <v-card-text class="red--text py-0 pb-3">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      #N/A
                    </blockquote>
                  </h3>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- ! MOST PUBLIC SELF -->
          <v-expansion-panel
            v-model="panel1"
            expand
            popout
          >
            <v-expansion-panel-content expand-icon="mdi-menu-down">
              <div
                slot="header">
                <h4 class="font-weight-medium">
                  Mask Public Self
                  <span
                    class="grey--text font-subtitle"
                  >(Gambaran kepribadian yang di tampilkan individu ketika berbaur dengan orang lain(topeng))</span>
                </h4>
              </div>
              <v-card v-if="applicant_detail.mask_public != null">
                <v-card-text class="blue--text py-0">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      {{applicant_detail.mask_public.disc_type}}
                      <v-icon color="grey" dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.mask_public.profile}}
                    </blockquote>
                  </h3>
                </v-card-text>
                <v-divider inset></v-divider>
                <v-card-text class="pt-0">
                  <h4>
                    <blockquote
                      style="font-size:14px"
                      class="font-italic font-weight-regular"
                    >{{applicant_detail.mask_public.characteristics}}</blockquote>
                  </h4>
                </v-card-text>
              </v-card>

              <v-card v-else>
                 <v-card-text class="red--text py-0 pb-3">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      #N/A
                    </blockquote>
                  </h3>
                </v-card-text>
              </v-card>
              
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- MIRROR PERCEIVED SELF -->
          <v-expansion-panel
            v-model="panel3"
            expand
            popout
          >
            <v-expansion-panel-content expand-icon="mdi-menu-down">
              <div slot="header">
                <h4 class="font-weight-medium">
                  Mirror Perceived Self
                  <span
                    class="grey--text font-subtitle"
                  >(Gambaran kepribadian yang sebenarnya terjadi atau yang terlihat oleh orang lain)</span>
                </h4>
              </div>
              <v-card v-if="applicant_detail.mirror_perceived != null">
                <v-card-text class="blue--text py-0">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      {{applicant_detail.mirror_perceived.disc_type}}
                      <v-icon color="grey" dark>mdi-arrow-right-thick</v-icon>
                      {{applicant_detail.mirror_perceived.profile}}
                    </blockquote>
                  </h3>
                </v-card-text>
                <v-divider inset></v-divider>
                <v-card-text class="pt-0">
                  <h4>
                    <blockquote
                      style="font-size:14px"
                      class="font-italic font-weight-regular"
                    >{{applicant_detail.mirror_perceived.characteristics}}</blockquote>
                  </h4>
                </v-card-text>
              </v-card>

              <v-card v-else>
                 <v-card-text class="red--text py-0 pb-3">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      #N/A
                    </blockquote>
                  </h3>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-model="panel4"
            expand
            popout
          >
            <v-expansion-panel-content expand-icon="mdi-menu-down">
              <div slot="header">
                <h4 class="font-weight-medium">Deskripsi Kepribadian</h4>
              </div>
              <v-card v-if="applicant_detail.mirror_perceived != null">
                <v-card-text>
                  <h4 class="text">
                    <blockquote style="font-size:14px"
                      class="font-italic font-weight-regular">{{applicant_detail.mirror_perceived.descriptions}}</blockquote>
                  </h4>
                </v-card-text>
              </v-card>

              <v-card v-else>
                 <v-card-text class="red--text py-0 pb-3">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      #N/A
                    </blockquote>
                  </h3>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            v-model="panel5"
            expand
            popout
          >
            <v-expansion-panel-content expand-icon="mdi-menu-down">
              <div slot="header">
                <h4 class="font-weight-medium">Job Match</h4>
              </div>
              <v-card v-if="applicant_detail.mirror_perceived != null">
                <v-card-text>
                  <h4>
                    <blockquote style="font-size:14px"
                      class="font-italic font-weight-regular">{{ applicant_detail.mirror_perceived.job_match}}</blockquote>
                  </h4>
                </v-card-text>
              </v-card>

              <v-card v-else>
                 <v-card-text class="red--text py-0 pb-3">
                  <h3>
                    <blockquote class="title font-weight-black font-italic">
                      #N/A
                    </blockquote>
                  </h3>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
      </v-card>
    </v-flex>

    <br />

    <v-flex>
      <v-card>
        <div>
          <v-subheader class="headline">Data Diri</v-subheader>
        </div>

        <v-divider />
        <table class="v-table mx-4">
          <tbody>
            <tr>
              <th class="text-xs-left font-weight-regular">No. KTP</th>
              <td >
                <v-icon small>more_vert</v-icon>
              </td>
              <td >{{applicant_detail.applicant.id_number}}</td>
            </tr>
            <tr>
              <th class="text-xs-left font-weight-regular">Nama</th>
              <td>
                <v-icon small>more_vert</v-icon>
              </td>
              <td>{{applicant_detail.applicant.name}}</td>
            </tr>
            <tr>
              <th class="text-xs-left font-weight-regular">Jenis Kelamin</th>
              <td>
                <v-icon small>more_vert</v-icon>
              </td>
              <td>{{applicant_detail.applicant.gender}}</td>
            </tr>
            <tr>
              <th class="text-xs-left font-weight-regular">Tanggal Lahir</th>
              <td>
                <v-icon small>more_vert</v-icon>
              </td>
              <td>{{applicant_detail.applicant.birthday_date | dateFormat}}</td>
            </tr>
            <tr>
              <th class="text-xs-left font-weight-regular">PIC</th>
              <td>
                <v-icon small>more_vert</v-icon>
              </td>
              <td>{{applicant_detail.user.name}}</td>
            </tr>
            <tr>
              <th class="text-xs-left font-weight-regular">Tanggal Test</th>
              <td>
                <v-icon small>more_vert</v-icon>
              </td>
              <td class="red--text font-weight-bold">
                {{ applicant_detail.test_date | dateFormat}}
              </td>
            </tr>
          </tbody>
        </table>
      </v-card>
    </v-flex>

    <v-flex >
      <div class="d-flex justify-space-between">
        <v-flex xs12 text-xs-left>
        <v-btn small round depressed color="tertiary" @click="$router.go(-1)">
          <strong>
            <v-icon small>mdi-arrow-left-bold-circle</v-icon>&nbsp;
            Kembali
          </strong>
        </v-btn>
        </v-flex>
        
        <v-flex xs12 text-xs-right>
        <v-btn small round :href="`${$axios.defaults.baseURL}` + '/pdf/' + $route.params.id" target="_blank" depressed color="success">
          <strong>
            <v-icon small >print</v-icon>&nbsp;
            Print
          </strong>
        </v-btn>
        </v-flex>
      </div>
    </v-flex>
  </v-container>
</template>

<style>
.font-subtitle {
  font-size: 12px;
  letter-spacing: 0.075em;
}
</style>

<script>
import { mapMutations } from "vuex";
import jsPDF from "jspdf";

export default {

  data () {
    return {
      user: "",
      result: null,
      panel1: [...Array(1).keys()].map(_ => false),
      panel2: [...Array(1).keys()].map(_ => false),
      panel3: [...Array(1).keys()].map(_ => false),
      panel4: [...Array(1).keys()].map(_ => false),
      panel5: [...Array(1).keys()].map(_ => false),

      titles: [
        "Mask Public Self",
        "Core Private Self",
        "Mirror Perceived Self"
      ],
      tab: null,
      applicant_detail: [],
      dialog: false,

      chartMost: {
        data: {
          labels: ["D", "I", "S", "C"],
          series: [[]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: -10,
          chartPadding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          }
        }
      },

      chartLeast: {
        data: {
          labels: ["D", "I", "S", "C"],
          series: [[]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: -10,
          chartPadding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          }
        }
      },

      chartChange: {
        data: {
          labels: ["D", "I", "S", "C"],
          series: [[]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: -10,
          chartPadding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          }
        }
      }
    };
  },

  filters: {

    dateFormat (date) {
      let newDate = new Date(date)

      let dd = newDate.getDate(); 
      let mm = newDate.getMonth() + 1;
      let yyyy = newDate.getFullYear();

      if(dd < 10 )
        dd = '0' + dd
      if(mm < 10)
        mm = '0' + mm
      
      let newFormat = dd + '-' + mm + '-' + yyyy

      return newFormat
    }
  },

  methods: {
    ...mapMutations("app", ["setAlert"]),
    back() {
      return this.$route.path === "/detail";
    },

    print() {
      let applicant = this.applicant_detail.applicant;
      let user = this.applicant_detail.user.name;
      let mask_public = this.applicant_detail.mask_public;
      let core_private = this.applicant_detail.core_private;
      let mirror_perceived = this.applicant_detail.mirror_perceived;
      let bottomWidth = 25;

      let newDate = new Date(this.applicant_detail.test_date);

      let dd = newDate.getDate();
      let mm = newDate.getMonth() + 1;
      let yyyy = newDate.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const pdf = new jsPDF();

      pdf.setFontSize(30);
      pdf.setFont("Roboto");
      pdf.text("DISC Test", 105, bottomWidth, null, null, "center");

      // ! BIODATA
      pdf.setLineWidth(0.3);
      pdf.line(10, bottomWidth + 6, 200, bottomWidth + 6);

      bottomWidth = bottomWidth + 18;
      pdf.setFontSize(12);
      pdf.text(
        "Nama       : " +
          applicant.name.charAt(0).toUpperCase() +
          applicant.name.substring(1),
        10,
        bottomWidth
      );
      pdf.text("No. KTP   : " + applicant.id_number, 10, bottomWidth + 6);

      pdf.text("Tanggal Tes : " + dd + "/" + mm + "/" + yyyy, 150, bottomWidth);
      pdf.text(
        "PIC\t       : " + user.charAt(0).toUpperCase() + user.substring(1),
        150,
        bottomWidth + 6
      );

      pdf.line(10, bottomWidth + 15, 200, bottomWidth + 15);

      // ! GAMBARAN KARAKTER
      bottomWidth = bottomWidth + 30;
      pdf.setFontSize(20);
      pdf.text("Gambaran Karakter", 105, bottomWidth, null, null, "center");

      bottomWidth = bottomWidth + 5;

      // ! MASK PUBLIC SELF
      pdf.setTextColor(100);
      let btmSpaceLineForContent = 1;
      pdf.setFontSize(14);
      pdf.setFontStyle("bold");
      pdf.text("Mask Public Self", 10, bottomWidth + 6);

      pdf.setFontSize(10);
      pdf.setTextColor(100);
      pdf.text(
        "(Gambaran kepribadian yang di tampilkan individu ketika berbaur dengan orang lain(topeng))",
        50,
        bottomWidth + 6
      );

      pdf.setTextColor(44, 155, 244);
      pdf.setFontSize(12);
      pdf.setFontStyle("bolditalic");
      pdf.text(
        mask_public.disc_type + " ~ " + mask_public.profile,
        15,
        bottomWidth + 6 * 2 + btmSpaceLineForContent + 2
      );

      // pdf.setLineWidth(0.1);
      pdf.setDrawColor(158, 158, 158);
      pdf.line(15, bottomWidth + 6 * 3, 200, bottomWidth + 6 * 3);

      pdf.setTextColor("black");
      pdf.setFontStyle("normal");
      var test = pdf.splitTextToSize(mask_public.characteristics, 180);
      pdf.text(test, 15, bottomWidth + 6 * 4 + btmSpaceLineForContent - 1);

      // ! CORE PRIVATE SELF
      pdf.setTextColor(100);
      bottomWidth = bottomWidth + 6 * 4 + btmSpaceLineForContent + 15;
      pdf.setFontSize(14);
      pdf.setFontStyle("bold");
      pdf.text("Core Private Self", 10, bottomWidth + 6);

      pdf.setFontSize(10);
      pdf.setTextColor(100);
      pdf.text(
        "(Gambaran kepribadian ketika menghadapi tekanan)",
        50,
        bottomWidth + 6
      );

      pdf.setTextColor(44, 155, 244);
      pdf.setFontSize(12);
      pdf.setFontStyle("bolditalic");
      pdf.text(
        core_private.disc_type + " ~ " + core_private.profile,
        15,
        bottomWidth + 6 * 2 + btmSpaceLineForContent + 1
      );

      pdf.setDrawColor(158, 158, 158);
      pdf.line(15, bottomWidth + 6 * 3, 200, bottomWidth + 6 * 3);

      pdf.setTextColor("black");
      pdf.setFontStyle("normal");
      var test = pdf.splitTextToSize(core_private.characteristics, 180);
      pdf.text(test, 15, bottomWidth + 6 * 4 + btmSpaceLineForContent - 1);

      // ! MIRROR PERCEIVED SELF
      pdf.setTextColor(100);
      bottomWidth = bottomWidth + 6 * 4 + btmSpaceLineForContent + 15;
      pdf.setFontSize(14);
      pdf.setFontStyle("bold");
      pdf.text("Mirror Perceived Self", 10, bottomWidth + 6);

      pdf.setFontSize(10);
      pdf.setTextColor(100);
      pdf.text(
        "(Gambaran kepribadian yang sebenarnya terjadi atau yang terlihat oleh orang lain)",
        60,
        bottomWidth + 6
      );

      pdf.setTextColor(44, 155, 244);
      pdf.setFontSize(12);
      pdf.setFontStyle("bolditalic");
      pdf.text(
        mirror_perceived.disc_type + " ~ " + mirror_perceived.profile,
        15,
        bottomWidth + 6 * 2 + btmSpaceLineForContent + 1
      );

      pdf.setDrawColor(158, 158, 158);
      pdf.line(15, bottomWidth + 6 * 3, 200, bottomWidth + 6 * 3);

      pdf.setTextColor("black");
      pdf.setFontStyle("normal");
      var test = pdf.splitTextToSize(mirror_perceived.characteristics, 180);
      pdf.text(test, 15, bottomWidth + 6 * 4 + btmSpaceLineForContent - 1);

      // ! DESKRIPSI KEPRIBADIAN
      pdf.setTextColor(100);
      bottomWidth = bottomWidth + 6 * 4 + btmSpaceLineForContent + 20;
      pdf.setFontSize(14);
      pdf.setFontStyle("bold");
      pdf.text("Deskripsi Kepribadian", 10, bottomWidth);

      pdf.setFontSize(12);
      pdf.setTextColor("black");
      pdf.setFontStyle("normal");
      var test = pdf.splitTextToSize(mask_public.descriptions, 180);
      pdf.text(test, 15, bottomWidth + 6 + btmSpaceLineForContent);

      // ! JOB MATCH
      pdf.setTextColor(100);
      bottomWidth = bottomWidth + 6 + btmSpaceLineForContent + 50;
      pdf.setFontSize(14);
      pdf.setFontStyle("bold");
      pdf.text("Job Match", 10, bottomWidth);

      pdf.setFontSize(12);
      pdf.setTextColor("black");
      pdf.setFontStyle("normal");
      var test = pdf.splitTextToSize(mask_public.job_match, 180);
      pdf.text(test, 15, bottomWidth + 6 + btmSpaceLineForContent);

      const chartistChart = document.getElementById("testing");
      pdf.addHTML(chartistChart, function() {
        const outputString = pdf.output("datauristring");
        // Changes the src to new data URI
        // previewPane.attr('src', outputString)
      });

      pdf.save("testing.pdf");
    }
  },

  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    let id = this.$route.params.id;
    let urlApplicant = "/applicants/" + id;
    let urlMost = "/getRefMost/" + id;
    let urlLeast = "/getRefLeast/" + id;
    let urlChange = "/getRefChange/" + id;
    let urlDefinition = "/getResult/" + id;

    this.axios
      .get(urlMost)
      .then(response => {
        let data = response.data;
        data.forEach(element => {
          this.chartMost.data.series[0].push(element);
        });
      })
      .catch(error => {
        let responses = error.response;
        console.log(responses);
      });

    this.axios
      .get(urlLeast)
      .then(response => {
        let data = response.data;
        data.forEach(element => {
          this.chartLeast.data.series[0].push(element);
        });
      })
      .catch(error => {
        let responses = error.response;
        console.log(responses);
      });

    this.axios
      .get(urlChange)
      .then(response => {
        let data = response.data;
        data.forEach(element => {
          this.chartChange.data.series[0].push(element);
        });
      })
      .catch(error => {
        let responses = error.response;
        console.log(responses);
      });

    // this.axios
    //   .get(urlApplicant)
    //   .then(response => {
    //     let applicant = response.data;
    //     this.applicant = applicant;

    //     applicant.forEach(element => {
    //       element.forEach(data => {
    //         this.result.push(data);
    //       });
    //     });
    //   })
    //   .catch(error => {
    //     let errors = error.response;
    //     console.log(errors);
    //   });

    this.axios
      .get(urlDefinition)
      .then(response => {
        let data = response.data.data;
        this.applicant_detail = data;

        // data.forEach(element => {
        //   element.forEach(data => {
        //     this.definition.push(data);
        //   });
        // });

        // user.forEach(element => {
        //   element.forEach(data1 => {
        //     this.user.push(data1);
        //   });
        // });
      })
      .catch(error => {
        let errors = error.response;
        console.log(errors);
      });
  }
};
</script>